import styles from './styles.module.scss'
import { useState, useEffect } from 'react'
import { BarChart } from './BarChart'
import Image from 'next/image'

export function RatingChart({ detailedReviewItems, scrollToHowWeRate }) {
  const [selectedCategory, setSelectedCategory] = useState('Overall')
  const [windowWidth, setWindowWidth] = useState(0)
  const [reviewsWithSelectedCategory, setReviewsWithSelectedCategory] =
    useState([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    setWindowWidth(window.innerWidth)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const findReviewsByCategory = () => {
      const reviews = detailedReviewItems.flatMap(review => {
        const matchingRatings = review.ratings.data.filter(rating => {
          return (
            rating.attributes.ratingAttribute.data.attributes.name ===
            selectedCategory
          )
        })

        return matchingRatings.map(matchingRating => ({
          reviewName: review.title,
          score: matchingRating.attributes.score,
          category:
            matchingRating.attributes.ratingAttribute.data.attributes.name,
        }))
      })

      setReviewsWithSelectedCategory(reviews)
    }

    findReviewsByCategory()
  }, [detailedReviewItems, selectedCategory])

  const handleCategoryClick = name => {
    setSelectedCategory(name)
  }

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  const relevantRatingAttributes = detailedReviewItems.reduce((acc, review) => {
    review.ratings.data.forEach(rating => {
      const attributeName =
        rating.attributes.ratingAttribute.data.attributes.name
      if (!acc.some(attr => attr.name === attributeName)) {
        acc.push({ name: attributeName })
      }
    })
    return acc
  }, [])

  return (
    <main className={styles.main}>
      <article className={styles.ratingCategories}>
        <h2 className={styles.title}>Ratings Details</h2>
        <div className={styles.namesContainer}>
          {windowWidth > 1024 ? (
            relevantRatingAttributes?.map((rating, index) => (
              <div
                key={index}
                onClick={() => handleCategoryClick(rating.name)}
                className={`${styles.nameBox} ${
                  selectedCategory === rating.name ? styles.selected : ''
                }`}
              >
                <h2 className={styles.name}>{rating.name}</h2>
              </div>
            ))
          ) : (
            <div className='dropdown'>
              <div className={styles.dropdown} onClick={toggleDropdown}>
                {selectedCategory}
                <Image
                  src='/assets/icons/icon-arrow-down.svg'
                  alt='Information'
                  width={16}
                  height={16}
                />
              </div>

              {isDropdownOpen && (
                <div className={styles.dropdownMenu}>
                  {relevantRatingAttributes?.map((rating, index) => (
                    <div
                      key={index}
                      className={`${styles.dropdownItem} ${styles.option}`}
                      onClick={() => {
                        handleCategoryClick(rating.name)
                        toggleDropdown() // Stäng dropdown efter att ett alternativ har valts
                      }}
                    >
                      {rating.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <button className={styles.ratingButton} onClick={scrollToHowWeRate}>
          How do we rate?
        </button>
      </article>
      <BarChart
        reviewsRatingData={reviewsWithSelectedCategory}
        selectedCategory={selectedCategory}
      />
    </main>
  )
}
